/* eslint-disable no-useless-escape */
import React from "react";
import Salert from "react-s-alert";
import PropTypes from "prop-types";

import {
  email_rule,
  pwd_rule,
  rucaptcha_rule,
  nickname_rule,
  mobile_rule,
  buildRules,
  vercode_rule,
} from "@shared/scripts/utils/validation_rules";
import CustomizeInput from "../shared/CustomizeInput";
import FormWrapper from "../utils/FormWrapper";

class SignupForm extends React.Component {
  updateRucaptcha = e => {
    const $rucaptcha = $(e.target);
    $rucaptcha.attr("src", $rucaptcha.attr("src"));
  };

  submit() {
    if (!this.props.isFormValidate()) return;

    const $form = $(this.refs.form);
    $form.ajaxSubmit({
      url: $form.attr("action"),
      type: "POST",
      dataType: "json",
      success: () => {
        Salert.success("注册成功");
        window.location.href = "/";
      },
      error: xhr => {
        Salert.error(xhr.responseText);
        $(this.refs.rucaptcha).click();
      },
    });
  }

  sendCode() {
    const {
      data: { code, mobile },
    } = this.props;

    if (code.value && code.valid && mobile.value && mobile.valid) {
      console.log("pass");
    }
  }

  render() {
    const {
      data: { email, password, name, code, mobile, phoneCode },
      changeValue,
    } = this.props;

    return (
      <form
        ref="form"
        action="/signup"
        className="signin-form"
        onKeyDown={e => {
          if (e.which === 13) this.submit();
        }}
      >
        <div className="form-header-area">
          <p className="form-header-title">注册</p>
          <p className="form-header-tips">
            已有账号？立即<span onClick={this.props.switchState}>登录</span>
          </p>
        </div>
        <input name="utf8" type="hidden" value="✓" />
        <CustomizeInput
          {...mobile}
          onChange={value => {
            changeValue(value, "mobile");
          }}
        />
        <div className="u-pic-code">
          <CustomizeInput
            {...code}
            onChange={value => {
              changeValue(value, "code");
            }}
          />
          <img
            ref="rucaptcha"
            src="/rucaptcha/"
            alt="图形验证码"
            onClick={e => this.updateRucaptcha(e)}
          />
        </div>
        <div className="u-pic-code u-pic-code--phone">
          <CustomizeInput
            {...phoneCode}
            onChange={value => {
              changeValue(value, "phone-code");
            }}
          />
          <div className="send-code" onClick={() => this.sendCode()}>
            发送验证码
          </div>
        </div>
        <CustomizeInput
          {...email}
          onChange={value => {
            changeValue(value, "email");
          }}
        />
        <CustomizeInput
          {...name}
          onChange={value => {
            changeValue(value, "name");
          }}
        />
        <CustomizeInput
          {...password}
          type="password"
          onChange={value => {
            changeValue(value, "password");
          }}
        />
        <a
          className="u-btn--black signin-form__submit"
          href="javascript:;"
          alt="注册"
          onClick={() => {
            this.submit();
          }}
        >
          注册
        </a>
        <div className="form-footer form-footer--register">
          注册即代表我已阅读并同意{" "}
          <a
            href="https://www.jiqizhixin.com/agreement/f7dd70ed-41d4-47c0-ad8f-5871ed7a03c8"
            target="_blank"
          >
            《用户协议》
          </a>
        </div>
      </form>
    );
  }
}

SignupForm.propTypes = {
  switchState: PropTypes.func.isRequired,
  isFormValidate: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  changeValue: PropTypes.func.isRequired,
};

export default FormWrapper({
  email: buildRules("user[email]", "邮箱", [email_rule]),
  password: buildRules("user[password]", "密码", [pwd_rule]),
  name: buildRules("user[name]", "昵称", [nickname_rule]),
  code: buildRules("_rucaptcha", "图形验证码", [rucaptcha_rule]),
  mobile: buildRules("mobile", "手机号", [mobile_rule]),
  phoneCode: buildRules("phoneCode", "验证码", [vercode_rule]),
})(SignupForm);
